import clsx from 'clsx';
import styles from './TextContent.module.scss';

type TextContentBaseProps = {
  limitWidth?: boolean;
  center?: boolean;
  testId?: string;
  textSize?: 'sm' | 'md' | 'lg' | 'xl' | 'smMd';
  className?: string;
};

type TextContentWithChildren = TextContentBaseProps & {
  children: React.ReactNode;
  dangerouslySetInnerHTML?: never;
};

type TextContentWithHtml = TextContentBaseProps & {
  children?: never;
  dangerouslySetInnerHTML: {
    __html: string;
  };
};

type TextContentProps = TextContentWithChildren | TextContentWithHtml;

export const TextContent: React.FC<TextContentProps> = ({
  children,
  dangerouslySetInnerHTML,
  limitWidth = false,
  center = false,
  testId,
  textSize = 'lg',
  className,
}) => (
  <div
    className={clsx(styles.content, className, {
      [styles.contentLimitWidth]: limitWidth,
      [styles.contentCenter]: center,
      [styles.contentTextSizeSm]: textSize === 'sm',
      [styles.contentTextSizeMd]: textSize === 'md',
      [styles.contentTextSizeLg]: textSize === 'lg',
      [styles.contentTextSizeXl]: textSize === 'xl',
      [styles.contentTextSizeSmMd]: textSize === 'smMd',
    })}
    data-testid={testId}
    {...(dangerouslySetInnerHTML && { dangerouslySetInnerHTML })}
  >
    {children}
  </div>
);
